import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Avatar from '../Avatar'
import MenuArrowIcon from '../icons/MenuArrowIcon'
import getLoginPortalUrl from '../../utils/getLoginPortalUrl'
import styles from './styles'

const MenuItem = ({ href, label }) => (

  <li className="menu-item">
    <a className="menu-link" href={href}>
      <p>{label}</p>
      <MenuArrowIcon />
    </a>
    <style jsx>{styles}</style>
  </li>
)

MenuItem.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

const LoadingMenuItem = () => (
  <li className="menu-item">
    <div className="menu-link loading">
      <MenuArrowIcon />
    </div>
    <style jsx>{styles}</style>
  </li>

)

const AccountSummary = ({
  firstName = '',
  currentlySubscribed = false,
  currentDomain,
  loginService,
  subscriptionType = '',
}) => {
  const profileHost = getLoginPortalUrl(currentDomain)
  const isLoading = firstName === ''

  useEffect(() => {
    // Hide the element with class 'PageFooter'
    const pageFooter = document.querySelector('.PageFooter')
    if (pageFooter) {
      pageFooter.style.display = 'none'
    }
  }, [])

  const handleLogOutButtonClick = async () => {
    await loginService.logOut()
    window.location = `https://player.${currentDomain}`
  }

  return (
    <div className="AccountSummary">
      <div className="account-summary">
        <div className="account-name">{!isLoading && <p>{`Hello ${firstName}`}</p>}</div>

        <div className={`avatar-container ${isLoading ? 'loading' : subscriptionType}`}>
          <Avatar userInitial={firstName?.charAt(0) || ''} summaryPage vipOptIn />
        </div>

        <div className="menu-body">
          <div className="manage-account">
            <h3 className={`menu-title ${isLoading ? 'loading' : ''}`}>{!isLoading && 'Manage account'}</h3>

            <ul className="account-menu">
              {isLoading ? (
                <>
                  <LoadingMenuItem />
                  <LoadingMenuItem />
                  <LoadingMenuItem />
                  <LoadingMenuItem />
                </>
              ) : (
                <>
                  <MenuItem href={`${profileHost}/personal-details`} label="Personal details" />
                  <MenuItem href={`${profileHost}/change-password`} label="Change password" />
                  <MenuItem href={`${profileHost}/marketing`} label="Marketing" />
                  <MenuItem href={`${profileHost}/privacy/personalisation`} label="Privacy" />
                </>
              )}
            </ul>
          </div>
          <div className="membership">
            <h3 className={`menu-title ${isLoading ? 'loading' : ''}`}>{!isLoading && 'Subscription & billing'}</h3>

            <ul className="membership-menu">
              {isLoading ? (
                <>
                  <LoadingMenuItem />
                  <LoadingMenuItem />
                </>
              ) : (
                <>
                  <MenuItem href={`${profileHost}/plan`} label="Manage subscription" />
                  {currentlySubscribed && <MenuItem href={`${profileHost}/payment-details`} label="Payment details" />}
                </>
              )}
            </ul>
          </div>
          <div className="sign-out-delete">
            <ul className="sign-out-delete-menu">
              <li className="menu-item">
                <button
                  className={`menu-link-button ${isLoading ? 'loading' : ''}`}
                  type="button"
                  onClick={!isLoading ? handleLogOutButtonClick : ''}
                >
                  {!isLoading && 'Sign out'}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

AccountSummary.defaultProps = {
  firstName: '',
  currentlySubscribed: false,
  subscriptionType: '',
}

AccountSummary.propTypes = {
  firstName: PropTypes.string,
  currentlySubscribed: PropTypes.bool,
  currentDomain: PropTypes.string.isRequired,
  loginService: PropTypes.shape({
    logOut: PropTypes.func,
    deleteUser: PropTypes.func,
    getUser: PropTypes.func,
  }).isRequired,
  subscriptionType: PropTypes.string,
}

export default AccountSummary
